// extracted by mini-css-extract-plugin
export var label = "_3w-1";
export var reminder = "_3w-0";